import { Title } from '@mui/icons-material';
import {
  Box,
  styled,
  TextField as TextFieldStyle,
  TableContainer as TableContainerStyles,
  TableHead as TableHeader,
  Button as Btn,
  css,
  TableContainer,
  Typography,
} from '@mui/material';

export const Container = styled(Box)`
  padding: 42px 30px 42px 30px;
  background: ${({ theme }) => theme.palette.grey[50]};
  width: 100%;
  height: 100%;
  overflow-y: overlay;
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;

  .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
    border-style: 'hidden';
  }
`;

export const TextInformation = styled(Typography)`
  margin-bottom: 5px;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  letter-spacing: 0.1px;
  color: #9e9e9e;
`;

export const TabSelection = styled(Box)`
  display: flex;
  flex-direction: row;
  background: #ffffff;
  border-radius: 4px;
  Button {
    width: 160px;
    height: 48px;
    padding: 17px 43px;
    border-radius: 0;
  }
`;

interface ButtonProps {
  active: boolean;
}

export const TabButton = styled(Btn)`
  color: rgba(0, 0, 0, 0.54);
  ${(props: ButtonProps) =>
    props.active &&
    css`
      font-weight: 800;
      border-bottom: 2px solid #206da7;
      color: #206da7;
    `}
`;

export const Button = styled(Btn)``;

export const Page = styled(Box)`
  margin-top: 20px;
`;

export const Div = styled(Box)`
  .title-members {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #212121;
  }
  .title-select {
    font-family: 'Roboto';
    font-style: normal;
    font-size: 15px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #0b79d0;
  }
  .header-table {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const TitleTable = styled(Box)`
  margin-top: 20px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #000000;
`;

export const TitleEditBoard = styled(Box)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #000000;
`;

export const SectionHeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Text = styled(Box)``;

export const ContainerUsers = styled(TableContainer)`
  overflow-y: auto;
  height: 53vh;

  @media (max-height: 928px) {
    height: 48vh;
  }

  @media (max-height: 865px) {
    height: 43vh;
  }

  @media (max-height: 755px) {
    height: 40vh;
  }

  @media (max-height: 728px) {
    height: 35vh;
  }

  @media (max-height: 675px) {
    height: 30vh;
  }

  @media (max-height: 625px) {
    height: 25vh;
  }

  @media (max-height: 575px) {
    height: 20vh;
  }
`;
